import { render, staticRenderFns } from "./ThankYou.v2.vue?vue&type=template&id=a8c317a0&scoped=true&"
import script from "./ThankYou.v2.vue?vue&type=script&lang=js&"
export * from "./ThankYou.v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c317a0",
  null
  
)

export default component.exports